import OnboardingDialog from './dialog';

export { OnboardingDialog };



// WEBPACK FOOTER //
// ./src/pages/onboarding/dialogs/index.js